<template>
  <div class="uk-text-bold uk-text-success">Anfrage wurde gesendet</div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      form: state => state.store.form,
      inquiry: state => state.store.inquiry
    }),
    getIframeUrl () {
      if (this.form && this.form.iframe_url) {
        return this.form.iframe_url
      }
      return false
    }
  }
}
</script>
